import { useEffect, useRef } from 'react';
import * as styles from './SmartBannerDetection.module.scss';
import { isIos } from '../utils';

/* 
  This component is used to detect if an iOS smart banner is being displayed on the page.
  Unfortunately there is no direct way to do this, so the measurement is conservative and defaults to "not detected".

  Component logic:
  - Measure lvh and svh, which are css units that measure the viewport heights when all expandable elements are expanded (svh) and or all are retracted (lvh). https://web.dev/blog/viewport-units
  - If the lvh is still larger than the svh + the expanded nav-height, the smart banner is likely also contributing to the lvh. In that scenario, 
    the smart banner is assumed to be displayed.
  - This logic assumes that the navbar and smart banner are the only expandable element on the page.
*/

const SmartBannerDetection = ({ onSmartBannerDetected }: { onSmartBannerDetected: () => void }) => {
  const lvhRef = useRef<HTMLDivElement>(null);
  const svhRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isIos()) return;

    const lvh = lvhRef.current?.clientHeight;
    const svh = svhRef.current?.clientHeight;

    const estimatedExpandedNavHeight = 120;
    if (lvh && svh) {
      const smartBannerDetected = lvh > svh + estimatedExpandedNavHeight;
      if (smartBannerDetected) {
        onSmartBannerDetected();
      }
    }
  }, [onSmartBannerDetected]);

  return (
    <>
      <div ref={lvhRef} className={styles.lvh} />
      <div ref={svhRef} className={styles.svh} />
    </>
  );
};
export default SmartBannerDetection;
